import { IExternalApiKey, IExternalApiKeyCreateResult } from '@common/interfaces/externalApi'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export interface IExternalApiKeyState {
  loadingArray: string[]
  apiKeys: {
    isLoading: boolean
    isSaving: boolean
    isSaved: boolean
    data: IExternalApiKey[] | null
  }
  createdKey: IExternalApiKeyCreateResult | null
}

export default combineReducers({
  loadingArray: loadingArrayReducer(
    [actions.prefix],
    [actions.LIST_API_KEYS_REQUEST, actions.CREATE_API_KEY_REQUEST, actions.REVOKE_API_KEY_REQUEST],
  ),
  apiKeys: createLoadingDataReducer<IExternalApiKey[]>(
    [actions.LIST_API_KEYS_REQUEST],
    [actions.CREATE_API_KEY_REQUEST, actions.REVOKE_API_KEY_REQUEST],
  ),
  createdKey(state: IExternalApiKeyCreateResult | null = null, action: IAction) {
    switch (action.type) {
      // Clear at the start of a new create so a failed/in-flight request can
      // never leave a stale secret from a previous creation visible.
      case actions.CREATE_API_KEY_REQUEST:
      case actions.REVOKE_API_KEY_SUCCESS:
        return null
      case actions.CREATE_API_KEY_SUCCESS:
        return action.data as IExternalApiKeyCreateResult
      default:
        return state
    }
  },
})
